import "bootstrap/dist/js/bootstrap.min.js";
import "@popperjs/core/dist/umd/popper.min.js";
import Swiper from 'swiper';
import "slick-carousel";

//header
const IndexHeroBanner = new Swiper('.swiper-container.index-banner-swiper', {
    preloadImages: false,
    spaceBetween: 0,
    slidesPerView: 1,
    speed: 1000,
    loop:true,
    navigation: {
    nextEl: '.swiper-button-next.index-banner-swiper-button-next',
    prevEl: '.swiper-button-prev.index-banner-swiper-button-prev',
    },
});

//promotions
const IndexpromotionsBanner = new Swiper('.swiper-container.promotions-swiper', {
        preloadImages: false,
        spaceBetween:20,
        speed: 1000,
        loop:true,
        navigation: {
        nextEl: '.swiper-button-next.promotions-swiper-button-next',
        prevEl: '.swiper-button-prev.promotions-swiper-button-prev',
        },
        autoplay: {
            delay: 3000,
        },
        breakpoints: {
            1900: {
                slidesPerView:3,
                allowTouchMove: true,
                spaceBetween:20,
            },
            1440: {
                slidesPerView:2,
                allowTouchMove: true,
            },
      }
});

//product
$(function(){
  $('.slider-for').slick({
    slidesToShow: 1, //預設 1 幻燈片顯示幾張
    slidesToScroll: 1,//預設 1 幻灯片每次滑動幾張
    arrows: false, // 預設 true 左右箭頭是否顯示
    fade: true, // 預設 false 淡入淡出
    asNavFor: '.slider-nav'//將滑塊設置為其他滑塊的導航（類或ID名稱）,適用於多個輪播圖共用一個導航
  });

  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false, // 預設 false 指示点
    arrows: false, // 預設 true 左右箭頭是否顯示
    focusOnSelect: true, // 預設 false
    vertical: true,
	responsive: [
		{
		  breakpoint: 576,
		  settings: {
			vertical: false,
		  }
		}]
   
  });
    
});


//detailRoomInfo
const detailRoomInfo = new Swiper('.swiper-container.detailRoomInfo-swiper', {
  preloadImages: false,
  spaceBetween: 0,
  slidesPerView: 1,
  speed: 1000,
  loop:true,
  pagination: {
    el: '.swiper-pagination',
  },
});

$('.circle-plus').on('click', function(){
  $(this).toggleClass('opened');
})

$('.circle-plus-two').on('click', function(){
  $(this).toggleClass('opened');
})

const MoveIndexHeroBanner = new Swiper('.swiper-container.move-index-banner-swiper', {
  preloadImages: false,
  spaceBetween: 0,
  slidesPerView: 1,
  speed: 1000,
  loop:true,
  navigation: {
  nextEl: '.swiper-button-next.index-banner-swiper-button-next',
  prevEl: '.swiper-button-prev.index-banner-swiper-button-prev',
  },
});


//文章
const articleSwiper = new Swiper('.swiper-container.articleSwiper', {
    preloadImages: false,
    spaceBetween: 0,
    slidesPerView: 1,
    speed: 1000,
    loop:true,
    navigation: {
    nextEl: '.articleSwiper-swiper-button-prev.swiper-button-prev',
    prevEl: '.articleSwiper-swiper-button-next.swiper-button-next',
    },
});







$(function(){
  $('.article-slider-for').slick({
    slidesToShow: 1, //預設 1 幻燈片顯示幾張
    slidesToScroll: 1,//預設 1 幻灯片每次滑動幾張
    fade: true, // 預設 false 淡入淡出
    arrows:true,
    asNavFor: '.article-slider-nav',//將滑塊設置為其他滑塊的導航（類或ID名稱）,適用於多個輪播圖共用一個導航
  });

  $('.article-slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.article-slider-for',
    dots: false, // 預設 false 指示点
    arrows: false, // 預設 true 左右箭頭是否顯示
    focusOnSelect: true, // 預設 false
    vertical:false,
    responsive: [
      {
        breakpoint: 992,
        settings:{
          slidesToShow: 1,
          slidesToScroll:1,
          infinite: true,
          dots: true
        }}
    ]
   
  });
    
});

